/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-15 14:57:17
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-15 15:10:40
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentGroup/ModulesGenerator/Poster.ts
 */
import { ActionType } from 'src/types/common/common';

import {
  //ProductList,
  //   LongCanvas,
  //   Text,
  //   Poster,
  //   ProductGridDisplay,
  Poster,
  //   ListAdaptor,
} from 'src/constrains/DraggableModules/Components';

const PosterFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const handleOnPosterStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };

  const handleOnPosterItemAdd = (id, arr) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.add, id, data: arr });
    }
  };

  const handleOnPosterItemReduce = (id, arr) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.reselect, id, data: arr });
    }
  };

  const handleOnPosterItemChange = (id, index, modifiedData) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.modify,
        id,
        data: {
          index,
          modifiedData,
        },
      });
    }
  };
  const handleOnPosterItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: {
          from,
          to,
        },
      });
    }
  };
  return {
    handleOnPosterStaticChange,
    handleOnPosterItemAdd,
    handleOnPosterItemReduce,
    handleOnPosterItemChange,
    handleOnPosterItemSort,
    //  handleOnPosterModuleTypeChange,
  };
};
const generatePoster = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  disabled,
}) => {
  const {
    handleOnPosterStaticChange,
    handleOnPosterItemAdd,
    handleOnPosterItemReduce,
    handleOnPosterItemChange,
    handleOnPosterItemSort,
  } = PosterFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
  });
  return {
    component: Poster,
    props: {
      onStaticChange: handleOnPosterStaticChange,
      onItemAdd: handleOnPosterItemAdd,
      onItemReduce: handleOnPosterItemReduce,
      onItemChange: handleOnPosterItemChange,
      onItemSort: handleOnPosterItemSort,
      disabled,
    },
  };
};
export { generatePoster };
